// Hook - aktualny status testu deliverability stopki (PENDING / OK / FAILED / NEVER_TESTED).
// GET /api/ui/sales-crm/mailbox/test-signature-deliverability/result
// Sprint 3 v4.1. Caller decyduje o pollowaniu (refetchInterval w options).

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetTestSignatureDeliverabilityResultResponse } from 'api/types/signature';

export const TEST_SIGNATURE_DELIVERABILITY_QUERY_KEY =
  'sales-crm-test-signature-deliverability' as const;

const getTestSignatureDeliverabilityResult =
  (): Promise<IGetTestSignatureDeliverabilityResultResponse> =>
    axios.get('/sales-crm/mailbox/test-signature-deliverability/result');

export const useGetTestSignatureDeliverabilityResult = (
  options?: UseQueryOptions<IGetTestSignatureDeliverabilityResultResponse, IError>
) =>
  useQuery<IGetTestSignatureDeliverabilityResultResponse, IError>(
    [TEST_SIGNATURE_DELIVERABILITY_QUERY_KEY],
    getTestSignatureDeliverabilityResult,
    {
      staleTime: 5_000,
      ...options
    }
  );
